<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
  >
    <path
      d="M38.2328 17.3761C38.2328 7.36244 30.6424 0.393066 19.731 0.393066C8.42478 0.393066 0.675781 8.21632 0.675781 19.6373C0.675781 31.4262 8.21891 38.9018 20.1225 38.9018C23.0318 38.9018 25.8229 38.4867 27.8985 37.7712V34.8619C26.4473 35.5336 23.3288 35.9689 20.1698 35.9689C10.2945 35.9689 3.92591 29.6239 3.92591 19.7757C3.92591 10.1772 10.4093 3.30232 19.4307 3.30232C28.6613 3.30232 34.9827 8.99932 34.9827 17.3288C34.9827 23.0056 33.1129 26.6742 30.2037 26.6742C28.5432 26.6742 27.5982 25.7292 27.5982 24.1092V10.5721H24.1152V13.3868H23.7439C22.8462 11.3787 20.7705 10.1333 18.3439 10.1333C13.6189 10.1333 10.3182 14.0551 10.3182 19.6609C10.3182 25.5233 13.548 29.4687 18.3473 29.4687C21.0473 29.4687 23.1229 28.1524 24.1152 25.8001H24.4864C24.7598 28.0613 26.859 29.6746 29.559 29.6746C34.8645 29.6746 38.2328 24.8989 38.2328 17.3794V17.3761ZM14.0104 19.7521C14.0104 15.7122 15.8329 13.3159 18.9244 13.3159C22.0632 13.3159 24.0679 15.8067 24.0679 19.7521C24.0679 23.6974 22.0395 26.2118 18.8772 26.2118C15.8565 26.2118 14.0104 23.7649 14.0104 19.7521Z"
      fill="#404A57"
    />
  </svg>
</template>

<script>
export default {
  name: "Icon@",
};
</script>

<style></style>
